import useAnimatedImage from '@moncler/components/routerTransitions/useAnimatedImage';
import imageutils, { LG, MD, SM, XS, XXS } from '@utils/imageutils';
import classNames from 'classnames';
import React, { useMemo, useRef } from 'react';
import useBreakpoint from '@utils/useBreakpoint';
const defaultSizes = [XXS, XS, SM, MD];
const ProductImage = (props) => {
    var _a;
    const el = useRef();
    const image = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (props.index != undefined) {
            let url = (_b = (_a = props.img) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b[props.index];
            if (props.genderImageSorted) {
                url = (_d = (_c = props.img) === null || _c === void 0 ? void 0 : _c[props.genderImageSorted]) === null || _d === void 0 ? void 0 : _d[props.index];
            }
            return url;
        }
        if (props.type) {
            let imageoldsuffix = '_' + props.type + '.';
            let imagenewsuffix = '_' + props.type + '1.';
            let img = (_f = (_e = props.img) === null || _e === void 0 ? void 0 : _e.urls) === null || _f === void 0 ? void 0 : _f.find((u) => u && (u.includes(imageoldsuffix) || u.includes(imagenewsuffix)));
            if (!img && props.type === 'X') {
                // fallback su F per vecchie immagini
                img = (_h = (_g = props.img) === null || _g === void 0 ? void 0 : _g.urls) === null || _h === void 0 ? void 0 : _h.find((u) => u && (u.includes('_F.') || u.includes('_F1.')));
            }
            if (img) {
                return img;
            }
        }
        return (_j = props.img) === null || _j === void 0 ? void 0 : _j.urls[0];
    }, [props.img, props.index, props.type]);
    // custom hook per animated image - funziona solo se tutti è tre i parametri sono valorizzati e mi trovo dentro AnimatedRoute
    if (((props === null || props === void 0 ? void 0 : props.index) == 0 || !(props === null || props === void 0 ? void 0 : props.index)) && el && props.animatedImage) {
        // useAnimatedImage(props.productId, el);
        useAnimatedImage(props.productId, el, props.productUuid);
    }
    const lowResImg = useMemo(() => { var _a; return imageutils.transform(image, XXS, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt); }, [image]);
    const currentBreakpoint = useBreakpoint();
    const hiResImage = useMemo(() => {
        var _a, _b;
        if (currentBreakpoint >= window.mqObj.md) {
            return imageutils.transform(image, LG, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt, null, 'avif');
        }
        else {
            return imageutils.transform(image, MD, (_b = props.img) === null || _b === void 0 ? void 0 : _b.alt, null, 'avif');
        }
    }, [currentBreakpoint, image]);
    const multipleSrc = useMemo(() => {
        let srcs = [];
        (props.sizes || defaultSizes).forEach((sz, i) => {
            var _a;
            srcs.push(`${imageutils.transform(image, sz, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt, props.imgQuality)} ${sz.width}w`);
        });
        return srcs.join(', ');
    }, [image]);
    const multipleSrcAvif = useMemo(() => {
        let srcs = [];
        (props.sizes || defaultSizes).forEach((sz, i) => {
            var _a;
            srcs.push(`${imageutils.transform(image, sz, (_a = props.img) === null || _a === void 0 ? void 0 : _a.alt, props.imgQuality, 'avif')} ${sz.width}w`);
        });
        return srcs.join(', ');
    }, [image]);
    const lazyPosterImg = useMemo(() => {
        return props.lazyLowRes ? lowResImg : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }, [image]);
    const altText = useMemo(() => {
        var _a, _b;
        const index = (_a = props.seoIndex) !== null && _a !== void 0 ? _a : props.index;
        return `${props.alt || ((_b = props.img) === null || _b === void 0 ? void 0 : _b.alt)}${index >= 0 ? ` ${index + 1}` : ''}`;
    }, [image]);
    const imageElement = (React.createElement("picture", { className: classNames({ lazyload: !props.lazyDisabled }, props.className) },
        React.createElement("source", Object.assign({}, (!props.lazyDisabled && { ['data-srcset']: multipleSrcAvif }), { srcSet: props.lazyDisabled ? multipleSrcAvif : lazyPosterImg, type: 'image/avif' })),
        React.createElement("source", Object.assign({}, (!props.lazyDisabled && { ['data-srcset']: multipleSrc }), { srcSet: props.lazyDisabled ? multipleSrc : lazyPosterImg, type: 'image/webp' })),
        React.createElement("img", { ref: props.ref || el, alt: altText, src: props.lazyDisabled ? hiResImage : lowResImg, "data-sizes": "auto", "data-idx": props.index || 0, className: classNames({ lazyload: !props.lazyDisabled }, props.className), "data-quality-img": hiResImage, 
            //width={"100%"}
            height: XXS.height, style: props.style, "aria-hidden": (props === null || props === void 0 ? void 0 : props.ariaHidden) != undefined ? props === null || props === void 0 ? void 0 : props.ariaHidden : !!props.alt || !!((_a = props.img) === null || _a === void 0 ? void 0 : _a.alt) })));
    if (props.onlyImage) {
        return imageElement;
    }
    if (!props.img) {
        return (React.createElement("div", { className: "product-image", "data-tiletype": props.tiletype, "data-type": props.type },
            React.createElement("img", { alt: "", src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkZmD+DwABGwEHEIRMfwAAAABJRU5ErkJggg==", "data-idx": props.index || 0, className: props.className, width: XXS.width, height: XXS.height, style: props.style })));
    }
    return (React.createElement("div", { className: "product-image", "data-tiletype": props.tiletype, "data-type": props.type }, imageElement));
};
export default ProductImage;
